import { addDays, parseISO } from "date-fns";

export const getDisabledDates = async (
  availabilitiesState: any,
  integration_TYPE: string
): Promise<string[]> => {
  const availabilities = availabilitiesState?.availabilities;
  const disabledDates: string[] = [];

  if (!availabilities || !integration_TYPE) {
    console.warn("No availabilities data or integration type defined.");
    return disabledDates;
  }

  try {
    if (integration_TYPE === "lodgify") {
      // Lodgify-specific date filtering
      return availabilities
        .filter((d: any) => !d.is_available)
        .flatMap((range: any) => getDatesInRange(range));
    } else if (integration_TYPE === "guesty") {
      // Guesty-specific date filtering
      return availabilities
        .filter((day: any) => day.status !== "available" && day.date)
        .map((datee: any) => (datee.date ? parseISO(datee.date).toISOString() : null))
        .filter((date:any): date is string => date !== null);
    }
  } catch (error: any) {
    console.error("Error fetching disabled dates:", error);
  }

  return disabledDates;
};

// Helper function to get all dates within a range for Lodgify
const getDatesInRange = (data: any): string[] => {
  //console.log(data)
  const { period_start, period_end } = data;
  if (!period_start || !period_end) {
    console.warn("Invalid period range data:", data);
    return [];
  }

  const dates: string[] = [];
  let currentDate = addDays(parseISO(period_start), 1);
  const endDate = parseISO(period_end);

  while (currentDate <= endDate) {
    dates.push(currentDate.toISOString());
    currentDate = addDays(currentDate, 1);
  }

  return dates;
};